<template>
    <div id="divReports" v-if="showReportPage === true" class="col-lg-12 mainArea top10">
        <div class="panel panel-primary">
            <div class="panel-body">
                <div class="row">
                    <div class="col-lg-12 text-right">
                        <button @click="exportRowsToCSV" class="btn btn-primary" id="btnGetCSV" v-if="filteredRows" 
                                                            :disabled="selectedReport === undefined">{{ $t("message.getCSV") }}</button>
                        <button @click="printerFriendly" class="btn btn-primary" id="btnPrinterFriendly" v-if="filteredRows" 
                                                            :disabled="selectedReport === undefined">{{ $t("message.printerFriendly") }}</button>                                    
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 text-center">
                        <h4>
                            <label class="controlLabel color-green" id="lblSuccess"></label>
                            <label class="controlLabel color-red" id="lblError"></label>
                            <label class="control-label">&nbsp;</label>
                        </h4>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label class="controlLabel" for="ddlReport">{{ $t("message.report") }}</label><br />
                        <select class="form-control" id="ddlReport" v-on:change="selectReport" v-model="selectedReport">
                            <option :value="undefined" disabled="disabled" selected="selected" hidden>{{ $t("message.selectAReport") }}</option>
                            <option v-for="report in reports" v-bind:value="report" :key="report">{{translateText(report.Description)}}</option>
                        </select>
                    </div>
                </div>

                <!--Premise ID-->
                <div v-if="selectedReport">
                    <div class="row" v-if="premises.length > 1 && selectedReport.UsePremise === true">
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <br />
                            <label class="controlLabel" for="ddlPremise">{{ $tc("message.servicePoints", premises.length) }}</label><br />
                            <select id="ddlPremise" class="form-control" v-model="selectedPremiseID" v-on:change="premiseChange">
                                <option selected :value="undefined">{{$t("message.selectLocation")}}</option>
                                <option v-for="premise in premises" v-bind:value="premise.PremiseId" :key="premise.PremiseId">{{premise.Address}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                
                <!--I ultimately decided I would allow for a start / end date area; since I didn't want to change by report and wanted to make
                certain they stayed constant as you changed reports -->
                <div class="row" v-if="selectedReport && selectedReport.DefaultReportDateRangeID !== 0 && selectedReport.DefaultReportDateRangeID !== null">
                    <br />
                    <div class="col-md-12">
                        <label class="controlLabel" for="ddlDateRange">{{ $t("message.date")}}</label><br />
                        <select id="ddlDateRange" class="form-control" v-model="selectedDateRange" v-on:change="rangeChange">
                            <option selected :value="0">{{$t("message.lastMonth")}}</option>
                            <option :value="1">{{$t("message.last3Months")}}</option>
                            <option :value="2">{{$t("message.last6Months")}}</option>
                            <option :value="3">{{$t("message.last9Months")}}</option>
                            <option :value="4">{{$t("message.customRange")}}</option>
                        </select>
                    </div>
                    <div class="col-md-5 padding-top-5" v-if="selectedDateRange === 4">
                        <div id="divStartDate" class="div-inline-block top10">
                            <label class="controlLabel" for="dpStartDate">{{ $t("message.startDate") }}</label><br />
                            <datepicker id="dpStartDate" v-model="startDate" :format="$t('message.dateformat')" :clearable="false" lang="en" type="date" 
                                :not-after="endDate" @input="beginChange"></datepicker>
                        </div>
                        <div class="div-inline-block top10">&nbsp;</div>
                        <div id="divEndDate" class="div-inline-block top10">
                            <label class="controlLabel" for="dpEndDate">{{ $t("message.endDate") }}</label><br />
                            <datepicker id="dpEndDate" v-model="endDate" :format="$t('message.dateformat')" :clearable="false" lang="en" type="date" 
                                :not-before="startDate" @input="endChange"></datepicker>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="selectedReport">
                    <!-- if you ever add any additional types for the criteria, you would add them here, copying the v-if from a previous control -->

                    <div class="col-md-4" v-for="criteria in selectedReport.ReportCriteria" :key="criteria.ID" id="divCriteria">
                    <div v-if="criteria.DisplayCriteria">
                        <br />
                        <label v-if="criteria.ControlType !== 'boolean'" class="controlLabel">{{criteria.Description}}</label>
                        <label class="controlLabel" style="color:crimson;" v-if="criteria.Required && criteria.ControlType !== 'boolean'">*</label>
                        <br />

                        <datepicker v-model="criteria.Value" :format="$t('message.dateformat')" :typeable="true" input-class="hasDatepicker"  v-if="criteria.ControlType === 'date'"></datepicker>
                        <input type="text" class="form-control" :id="'txt' + criteria.ID"  v-model="criteria.Value"  v-if="criteria.ControlType === 'text'" />
                        <input type="number" class="form-control" :id="'num' + criteria.ID"  v-model="criteria.Value"  v-if="criteria.ControlType === 'number'" />
                        <select placeholder="Select" :id="'select' + criteria.ID" class="form-control" v-model="criteria.Value"  v-if="criteria.ControlType === 'dropdown'" v-on:change="showModal=false;">
                            <option value="" disabled="disabled" selected="selected" hidden>Select...</option>
                            <option v-for="option in criteria.ReportCriteriaOptions" v-bind:value="option.Value" :key="option.Value">{{option.Text}}</option>
                        </select>
                        <div v-if="criteria.ControlType === 'multi'">
                            <select class="form-control" multiple="multiple" style="height:150px;" size="4" v-model="criteria.ValueList">
                                <option @click="CheckAll(criteria);" style="font-weight:bold;">Select All</option>
                                <option v-for="option in criteria.ReportCriteriaOptions" v-bind:value="option.Value" :key="option.Value">{{option.Text}}</option>
                            </select>
                        </div>
                        <div v-if="criteria.ControlType === 'boolean'">
                            <!--Checkboxes we put the description AFTER the checkbox, on line with other controls.-->
                            <br />
                            <input type="checkbox" v-model="criteria.value" />
                            <label class="controlLabel">{{criteria.Description}}</label>
                            <label class="controlLabel" style="color:crimson;" v-if="criteria.Required">*</label>
                        </div>
                    </div>
                    </div>
                </div>

                <div class="row top10">
                    <div class="col-md-4">
                    <br />
                        <button type="button" id="btnReport" class="btn btn-primary" v-if="selectedReport !== null" v-on:click="runReport" 
                                    :disabled="selectedReport === undefined">{{ $t("message.runReport") }}</button>
                    </div>
                </div>

                <div class="row" id="divRpt" v-if="reportHasRun">
                    <!--Top "Add HTML" logic-->
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <br />
                        <div v-html="TopAddHTML" v-if="TopAddHTML !== ''"></div>
                    </div>
                    <!--Pagination logic-->
                    <div id="divReportContainer" class="col-lg-12 col-md-12 col-sm-12 col-xs-12" v-if="filteredRows">
                        <div class="PayGo_align_text_center" colspan="100" v-if="pageCount > 1" style="padding-bottom:5px;">
                            <nav role="navigation" aria-label="Pagination Navigation">
                                <div class="PayGo_align_text_center">
                                    <input type="submit" class="fa fa-angle-double-left btn btn-primary btnExtra" style="margin-right:3px;padding:5px;" @click="ChangePage(1)" 
                                                            :disabled="CurrentPage === 1" v-show="pageCount > 5" value="<<" aria-label="Back to first page" />
                                    <input type="submit" class="fa fa-angle-left btn btn-primary btnExtra" style="margin-right:3px;padding:5px;" @click="ChangePage(CurrentPage - 1)" 
                                                            :disabled="CurrentPage === 1" value="<" aria-label="Previous" />
                                    <input type="submit" style="margin-right:3px;padding:5px;" v-for="pg in displayPages" :key="pg" 
                                                            :class="CurrentPage === pg ? 'btn btn-primary:focus btnExtra': 'btn btn-primary btnExtra'" :value="pg" @click="ChangePage(pg)" />
                                    <input type="submit" class="fa fa-angle-right btn btn-primary btnExtra" @click="ChangePage(CurrentPage + 1)" style="margin-right:3px;padding:5px;" 
                                                            :disabled="CurrentPage === pageCount" value=">" aria-label="Next" />
                                    <input type="submit" class="fa fa-angle-double-right btn btn-primary btnExtra" @click="ChangePage(pageCount)" style="margin-right:3px;padding:5px;" 
                                                            :disabled="CurrentPage === pageCount" v-show="pageCount > 5" value=">>" aria-label="Go to last page" />
                                    <label style="margin-left:10px;" class="control-label">Records: {{filteredRows.length}}</label>
                                </div>
                            </nav>                            
                        </div>
                        <table v-if="currentRows.length > 0" class="PayGo_report_main_table table-responsive">
                            <thead>
                                <tr>
                                    <th scope="col" v-if="hasSubReport()" class="PayGo_report_table_header">&nbsp;</th>
                                    <th scope="col" v-for="(col, index) in reportOnlyColumns" :key="col.ReportColumnID" class="PayGo_report_table_header">
                                        <div class="PayGo_full_width">
                                            <div style="float: left; text-align: left;">
                                                <div class="PayGo_report_item_padding PayGo_report_word_wrap" @click="sortGrid(index)">
                                                    <label class="PayGo_pointer PayGo_report_column_header PayGo_report_word_wrap">{{translateText(col.Title)}}</label>
                                                    <img class="PayGo_report_sort_icon" :src="showSortImage(col.SortOrder < 0)" v-if="col.SortOrder != 0" alt="Sort Icon" />
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                    <th scope="col" class="PayGo_report_table_header">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <!--Here I use a template because, in the event of subreports, one row actually requires two tr rows.  A template handles this for us;
                                    otherwise v-for iterating over a collection could only do it on a row-to-row basis.-->
                                <template v-for="(row, rowIndex) in currentRows">
                                    <!-- If subreport exists we are going to append 'rpt-subrpt-click' class which is used to show pointer on the clickable row -->
                                    <!-- When the subreport is expanded we want to hide the bottom border that shows up on the parent tr (row) -->
                                    <tr :key="rowIndex"  :class="row.subReport !== '' ? row.expanded ? 'rpt-subrpt-click rpt-subrpt-expanded' : 'rpt-subrpt-click' : ''">
                                        <td scope="row" v-if="hasSubReport()" :class="row.hovered ? 'PayGo_report_table_row_hover' : rowIndex % 2 == 0 ? 'PayGo_report_table_row_white' : 'PayGo_report_table_row_grey'"
                                            @mouseover="row.hovered = true;" @mouseout="row.hovered = false;" @click="row.expanded = !row.expanded;" >
                                            <img v-bind:src="showRowImage(!row.expanded)" v-if="row.subReport !== ''" alt="Expand Row Icon" />
                                        </td>
                                        <td v-for="(val, index) in row.RowValues" :key="index" 
                                            :class="row.hovered ? 'PayGo_report_table_row_hover' : rowIndex % 2 == 0 ? 'PayGo_report_table_row_white' : 'PayGo_report_table_row_grey'"
                                            @mouseover="row.hovered = true;" @mouseout="row.hovered = false;"
                                            :style="Columns[index] !== undefined && Columns[index].DisplayLocation === reportOnlyDisplayLocation ? '' : 'display: none;'">
                                            <div class="PayGo_full_width">
                                                <div class="float: left; text-align: Left;">
                                                    <div class="PayGo_report_item_padding PayGo_report_word_wrap">
                                                        <span class="PayGo_report_word_wrap" @click="row.expanded = !row.expanded;" v-if="Columns[index] !== undefined && Columns[index].ValueType === 'text' && Columns[index].ColumnType !== 'currency' && (Columns[index].ColumnType !== 'popuplinkbutton' || !row.showLink)">{{val}}</span>
                                                        <span :class="ChangeNumeric(val) < 0 ? 'negativered PayGo_report_word_wrap' : 'PayGo_report_word_wrap'" @click="row.expanded = !row.expanded;" v-if="Columns[index] !== undefined && Columns[index].ValueType === 'text' && Columns[index].ColumnType === 'currency'">{{val}}</span>
                                                        <div v-html="val" v-if="Columns[index] !== undefined && Columns[index].ValueType === 'html'" @click="row.expanded = !row.expanded;" ></div>
                                                        <span class="btn-link" v-if="Columns[index] !== undefined && row.showLink" @click="openPopup(JSONParse(val).ID, Columns[index].PopupDetails)">{{JSONParse(val).Value}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <!---putting buttons in one column so they always appear together.  Button definition come from Report_Columns, as "Button" type.  The linkFrame
                                        should be what to call; see the notes on the Ajax Worker to set this up.  ColumnHeader is the header, sortorder is how fast they come in-->
                                        <td :class="row.hovered ? 'PayGo_report_table_row_hover' : rowIndex % 2 == 0 ? 'PayGo_report_table_row_white' : 'PayGo_report_table_row_grey'"
                                            @mouseover="row.hovered = true;" @mouseout="row.hovered = false;" nowrap>
                                            <div class="PayGo_full_width">
                                                <div class="float: left; text-align: Left;">
                                                    <div class="PayGo_report_item_padding PayGo_report_word_wrap">
                                                        <span v-for="btn in row.Buttons" :key="btn.Description">
                                                            <button class="btn btn-primary" @click="showDialogFrame(btn.Header, btn.URL, btn.Height, btn.Width)" v-if="btn.ValueType === 'buttondialog'">{{btn.Description}}</button>
                                                            <button class="btn btn-primary" @click="showConfirm(btn.Header, btn.Title, btn.URL)" v-if="btn.ValueType === 'buttonconfirm'" >{{btn.Description}}</button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="row.expanded && row.subReport != ''" :key="rowIndex">
                                        <td scope="row" colspan="100" :class="row.hovered ? 'PayGo_report_table_row_hover' : rowIndex % 2 == 0 ? 'PayGo_report_table_row_white' : 'PayGo_report_table_row_grey'"
                                            @mouseover="row.hovered = true;" @mouseout="row.hovered = false;">
                                            <div class="PayGo_report_item_padding" v-html="row.subReport"></div>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    <!--No rows logic.  We use a variable in a div v-if above to determine that the report has run, but we still have no data.-->
                    <div v-if="filteredRows.length === 0 && reportHasRun" class="col-md-12">
                        <br />
                        <label class="controlLabel">No Data was returned for selected criteria.</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-usage">
            <UsageStatementModal :selectedPremiseId="selectedPremiseID" :selectedBillingCycleAssignmentId="billingCycleAssignmentID" 
                                    :isUsageStatementModalVisible="showModal"></UsageStatementModal>
        </div>
        <!--Generic, used for popup buttons.  Uses a method to go get a ReportDataReturn object; though it uses much less logic (for now at least)-->
        <modal v-if="popupData" v-show="showGenericModal" @close="closeModal()" :modalWidth="popupData.width + 'px'" :displayFooter="false">
            <h4 class="modal-title" slot="header">{{popupData.title}}</h4>
            <div slot="body">
                <!--If you pass html, we will display it; otherwise we show the grid-->
                <table class="PayGo_report_main_table table-responsive">
                    <thead>
                        <tr>
                            <th v-for="(col, index) in popupData.columns" :key="index" class="PayGo_report_table_header">
                                <div class="PayGo_full_width">
                                    <div style="float: left; text-align: left;">
                                        <div class="PayGo_report_item_padding PayGo_report_word_wrap">
                                            <label class="PayGo_pointer PayGo_report_column_header PayGo_report_word_wrap">{{translateText(col.Title)}}</label>
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, rowIndex) in popupData.rows" :key="rowIndex">
                            <td v-for="(val, index) in row.RowValues" :key="index" 
                                :class="row.hovered ? 'PayGo_report_table_row_hover' : rowIndex % 2 == 0 ? 'PayGo_report_table_row_white' 
                                : 'PayGo_report_table_row_grey'"
                                @mouseover="row.hovered = true;" @mouseout="row.hovered = false;">

                                <span class="PayGo_report_word_wrap" v-if="Columns[index] !== undefined && Columns[index].ValueType === 'text'">{{val}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </modal>
    </div>
</template>

 <script>    
    import axios from "axios";
    import router from "../../router/index";
    import {store} from "../../store/index";
    import vuejsDatepicker from "vue2-datepicker";
    import UsageStatementModal from '@/components/dashboard/UsageStatementModal';
    import Modal from '@/components/common/Modal';
    export default {
    router,
    name: 'Reports',
    store,
    components: 
    {
        Modal,
        Datepicker: vuejsDatepicker,
        UsageStatementModal
    },
    //Pre-defining your variables prevents you from having to wire them to automatically update.
    //It's no coincidence that some of these are upper and some lower case... in general, if the source is c#, I have kept them the standard of upper-case
    //If they come from the javascript side, I am keeping them lower.
    data() {
        return {
            Rows: [],
            filteredRows: [],
            filterColumn: -1,
            filterCriteria: '',
            reportHasRun: false,
            sortKey: '',
            CurrentPage: 1,
            PageSize: 10,
            PageSizeUse: 10,
            ShowCriteria: true,
            ShowFilter: false,
            selectedRow: null,
            reportData: [],
            selectedReport: undefined,
            Columns: [],
            topAddHTML: "",
            reports: this.$store.getters.getReports,
            currentRows: [],
            //For the usage statement
            showModal: false,
            showGenericModal: false,
            billingCycleAssignmentID: 0,
            showReportPage: false,
            startDate: this.$store.getters.getStartDate,
            // Initialize End date to today's date everytime we load this component 
            endDate: new Date(),
            selectedDateRange: this.$store.getters.getSelectedDateRange,
            premises: this.$store.getters.getPremises,
            selectedPremiseID : this.$store.getters.getSelectedPremiseID,
            reportOnlyDisplayLocation: this.$ReportDislayLocation.ReportAndCSV,
            popupData: {}
        }
    },

    computed: {
        //This function ended up unused, since the page counter was "mostly cute" and would need to go away if we start calling back on page change.
        pageCount: function() {
            if (this.reports === undefined)
            {
                return 0;
            }
            if (!this.reports || !this.filteredRows)
            {
                return 0;
            }
            if (this.PageSizeUse === 0)
            {
                this.PageSizeUse = 10;
            }
            return Math.ceil(this.filteredRows.length / this.PageSizeUse);
        },

        //Function to splice out the records we need to show for pagination, with a 5-page show count.
        displayPages: function() {
            var rtn = [];
            var lowEnd = 1;
            var highEnd = 5;
            if (this.pageCount <= 5)
            {
                highEnd = this.pageCount;
            }
            else if (this.CurrentPage <= 3)
            {
                //Do nothing... the default works fine here.
            }
            else if (this.CurrentPage + 2 > this.pageCount)
            {
                lowEnd = this.pageCount - 5;
                highEnd = this.pageCount;
            }
            else
            {
                lowEnd = this.CurrentPage - 2;
                highEnd = this.CurrentPage + 2;
            }
            for (var i = lowEnd; i <= highEnd; i++) {
                rtn.push(i);
            }
            return rtn;
        },
        reportOnlyColumns() {
            return this.Columns.filter(col => col.DisplayLocation === this.reportOnlyDisplayLocation);
        }
    },
    methods: {
        JSONParse: function(jsonString) {
            try

            {
                return JSON.parse(jsonString);
            }
            catch(error)
            {
                return jsonString;
            }
            
        },
        //Generic method popup for buttons.
        openPopup(id, columnDetails)
        {
            axios({
                method: "POST",
                data: {
                    ID: id
                },
                url: this.$httpAxiosBaseUrl() + "Report/" + columnDetails.MethodName + "?date=" + new Date().getTime()
            }).then(result => {
                
                    var response = result.data;
                    if (response)
                    {
                        this.openModal({"ID": id, "title": columnDetails.Title, "width": columnDetails.Width, "topAddHTML": response.TopAddHTML, "columns": response.Columns, "rows": response.Rows});
                    } 
                }
            );   
        },
        openModal(data) {
            this.showGenericModal = true;
            //Makes a copy, does not assign to the original.
            this.popupData = Object.assign({}, data);
        },
        closeModal() {
            this.showGenericModal = false;
        },
        showRowImage: function(showMore) {
            if (showMore)
            {
                return require('@/assets/img/show_more.png');
            }
            return require('@/assets/img/show_less.png');
        },
        showSortImage: function(sortDesc) {
            if (sortDesc)
            {                                                          
                return require('@/assets/img/sort_desc.png');
            }
            return require('@/assets/img/sort_asc.png');
        },
        hasSubReport: function() {
            var rtn = false;
            for(var ctr = 0; ctr < this.currentRows.length; ctr++)
            {
                if (this.currentRows[ctr].subReport !== '')
                {
                    rtn = true;
                    break;
                }
            }
            return rtn;
        
        },
        //Hides the run report, to avoid one report being selected but a different one showing.
        selectReport: function () {
            this.showModal=false;
            this.getDatesForPremise();
            if (this.reportHasRun)
            {
                this.ShowCriteria = true;
                this.ShowFilter = false;
                this.reportHasRun = false;
            }

        },
        changeCurrentRows: function() {
            this.currentRows = this.filteredRows.length > 0 ? this.filteredRows.slice((this.CurrentPage - 1) * this.PageSizeUse, (this.CurrentPage * this.PageSizeUse)) : null;
        },
        //date range start and end changing.
        beginChange: function() {
            if (this.startDate === undefined || this.startDate === "" || this.startDate === null)
            {
                this.startDate = this.$store.getters.getStartDate;
            }
            store.commit('setStartDate', this.startDate);
        },
        endChange: function() {
            if (this.endDate === undefined || this.endDate === "" || isNaN(this.endDate) || this.endDate === null) {
                this.endDate = this.$store.getters.getEndDate;
            }
            store.commit('setEndDate', this.endDate);
        },
        rangeChange: function() {
            store.commit('setSelectedDateRange', this.selectedDateRange);
            if (this.selectedDateRange !== 4)
            {
                //if not a custom range, null out the values and get the new value;
                store.commit('setStartDate', null);
                store.commit('setEndDate', null);
                this.startDate = this.$store.getters.getStartDate;
                this.endDate = this.$store.getters.getEndDate;
            }

        },
        premiseChange: function() {
            store.commit('setSelectedPremiseID', this.selectedPremiseID);
            this.showModal = false;
            this.selectReport();
        },
        getDatesForPremise: function() {
            //We only care here if this is the usage statement.
            if (this.selectedReport.ID !== this.$reportTypes.UsageStatement)
            {
                return;
            }

            var path = this.$httpAxiosBaseUrl() + "Report/UsageDatesForPremiseID";
            axios({
                method: "POST",
                url: path,
                data: {
                    "premiseId": this.selectedPremiseID
                }
            }).then(result => {
                 if (result !== null && result !== undefined)
                {
                    if (this.selectedReport.ReportCriteria[0].DataKey==="UsageID") {
                        this.selectedReport.ReportCriteria[0].ReportCriteriaOptions = result.data;
                        this.selectedReport.ReportCriteria[0].Value = "-1";
                    }
                }
            });
        },
        translateText(pageText) {
            if (pageText === undefined) {
                return ""
            }

            var languages = this.$i18n.messages
            var currentLanguage = this.$i18n.locale
            
            // Check if current language is part of our set up
            if (currentLanguage in languages) {
                // Get all the messages for this language
                var currentLanguageMessages = languages[currentLanguage].message
                if (currentLanguageMessages !== null && (pageText !== "")) {
                    var languageText = currentLanguageMessages[pageText.replace(/ /g, "").toLowerCase()]
                    return languageText !== undefined ? languageText : pageText
                }
            }
            
            return pageText
        },
        //The Ajax call on running a report.
        runReport: function () {
            var self = this;

            // Reset modal flag before loading data points for modal
            self.showModal = false;
            //reset defaults
            self.currentRows = [];
            self.filteredRows = [];
            self.reportHasRun = false;

            //Custom formats to adjust to what c#/SQL need.
            var failedValidate = "";
            var failedValidateCount = 0; 
            
            //Check to see if any required fields don't have values.
            for (var index = 0, len = this.selectedReport.ReportCriteria; index < len; index++) {
                var value = this.selectedReport.ReportCriteria[index];
                var addToList = false;
                
                if (value.ControlType !== 'multi')
                {
                    if (value.Required === true && (value.Value === null || value.Value === undefined || value.Value.toString().trim() === '')) {
                        addToList = true;
                    }
                }
                else
                {
                    if (value.ValueList !== undefined)
                    {
                        //Check to see if any of them are checked.
                        if (value.ValueList.length === 0)
                        {
                            addToList = true;
                        }
                    }
                }
                if (addToList)
                {
                    failedValidateCount += 1;
                    if (failedValidate != "") {
                        failedValidate += ",";
                    }
                    failedValidate += value.Description;
                }
                if (value.ControlType === 'date' && Date.parse(value))
                {
                    //Breaking down a moment formatted date using no libraries.
                    value.Value = $.datepicker.formatDate("mm/dd/yy", new Date(value.Value));
                }
            }
            if (failedValidateCount > 0) {
                if (failedValidateCount === 1) {
                    this.showError(failedValidate + " is a required field.");                    
                    return;
                }
                else {
                    this.showError("The following fields are required: " + failedValidate);
                    return;
                }

            }
            //The usage report is very unique.
            if (self.selectedReport.ID === this.$reportTypes.UsageStatement)
            {
                this.billingCycleAssignmentID = Number(this.selectedReport.ReportCriteria[0].Value);
                this.selectedPremiseID = this.getSelectedPremiseIdForUsageStatement();
                this.showModal = true;
            }
            else {
                if (self.selectedReport.DefaultReportDateRangeID !== undefined && self.selectedReport.DefaultReportDateRangeID !== null) {
                    self.selectedReport.StartDate = this.startDate;
                    self.selectedReport.EndDate = this.endDate;
                    self.selectedReport.PremiseId = this.selectedPremiseID;
                }

                axios({
                    method: "POST",
                    url: this.$httpAxiosBaseUrl() + "Report/ReadCustomerReport",
                    data: {
                        reportReturn: JSON.stringify(self.selectedReport)
                    }
                }).then(result => {
                    if (result !== null && result !== undefined) {
                        result = result.data;
                        //I tried making this generic so we could make other pages like this, but as the buttons have to be very specific, I ended up hardcoding up this piece.  If we have
                        //more IFrames, we'll need to follow the template below
                        if (result.Rows.length > 0) {
                            self.Columns = result.Columns;
                            self.Rows = result.Rows;
                            self.filteredRows = result.Rows;                            
                            self.topAddHTML = result.TopAddHTML;
                            self.ChangePage(1);
                            if (self.selectedReport.ID === this.$reportTypes.MeterStatusHistory) {
                                // For Meter Status History we want to sort by the second column (Change Date)
                                self.sortGrid(1, -1);
                            } else {
                                self.sortGrid(0, -1);
                            }
                        }
                        else {
                            //No records returned.
                            self.Columns = [];
                            self.$data.Rows = [];
                            self.$data.filteredRows = [];
                            self.$data.TopAddHTML = '';
                        }   
                    }
                    self.$data.reportHasRun = true;
                    //Hide the criteria to make the page look cleaner, at least at first.
                    self.ShowCriteria = false;
                    
                });
            }
        },
        getSelectedPremiseIdForUsageStatement() {
            var currentSelectedPremiseId = this.selectedPremiseID;
            if (currentSelectedPremiseId > 0) {
                // This property will be set if we have multiple premises for this customer, as user will have to select a premise before they click on run report
                return currentSelectedPremiseId;
            } else {
                // We only have a single premise for this customer, let's go ahead and get that first one from our object
                return this.premises.length > 0 ? this.premises[0].PremiseId : -1; 
            }
        },
        //Checks to see if this is a start or end date; if it is, we then check to see if the opposite is over.
        checkCriteria: function(useCrit)
        {
            
            switch (useCrit.ID)
            {
                case this.$configureReportTypes.StartDate:
                {
                    for (var ctr = 0; ctr < this.selectedReport.ReportCriteria.length; ctr++)
                    {
                        if (this.selectedReport.ReportCriteria[ctr].ID == this.$configureReportTypes.EndDate)
                        {
                            if (dates.compare(useCrit.Value,this.selectedReport.ReportCriteria[ctr].value) === 1)
                            {
                                this.selectedReport.ReportCritia[ctr].Value = useCrit.Value;
                                
                            }
                            break;
                        }
                    }
                    break;
                }
                case this.$configureReportTypes.EndDate:
                {
                    for (var ctr = 0; ctr < this.selectedReport.ReportCriteria.length; ctr++)
                    {
                        if (this.selectedReport.ReportCriteria[ctr].ID == this.$configureReportTypes.StartDate)
                        {
                            if (dates.compare(useCrit.Value,this.selectedReport.ReportCriteria[ctr].value) === -1)
                            {
                                this.selectedReport.ReportCritia[ctr].Value = useCrit.Value;
                                
                            }
                            break;
                        }
                    }
                    break;
                }
                default:
                {
                    return;
                }

            }
        },
        resetExpandedAndHoveredFlagsForRows(rowsToReset) {
            for(var i = 0; i < rowsToReset.length; i++) {
                var rowData = rowsToReset[i];
                rowData.expanded = false;
                rowData.hovered = false;
            }
        },
        //Sorts
        sortGrid: function(idx, directionOverRide = 0) {
            // Before we being sorting the Report rows (rows and filteredRows), we will need to reset the expanded/hovered flags so we don't have to worry about 
            // sorting and associating SubReportHtml value again with its parent row.
            this.resetExpandedAndHoveredFlagsForRows(this.Rows);
            this.resetExpandedAndHoveredFlagsForRows(this.filteredRows);

            var self = this;
            for (var index = 0, len = this.Columns.length; index < len; index++) {
                var val = this.Columns[index];

                if (idx === index) {
                    val.SortOrder = val.SortOrder === 1 ? -1 : 1;
                    if (directionOverRide != 0) {
                        val.SortOrder = directionOverRide;
                    }               
                    
                    if (val.ColumnType === 'currency' || val.ColumnType === 'number') {
                        //We apply to both "Rows" and filtered rows; in case filter is removed.
                        this.Rows.sort(function (a, b) {
                            //Compare, stripping off dollars. Will eventually need to make this more robust if we start using foreign currencies.
                            //Regular expression removes starting parenthisis (replacing with - for negative) and ending parenthisis, plus all $.
                            var first = self.ChangeNumeric(a.RowValues[index]);
                            var second = self.ChangeNumeric(b.RowValues[index]);
                            

                            if (isNaN(first)) {
                                //Non-numerics go to "top"
                                return val.SortOrder;
                            }
                            if (isNaN(second)) {
                                //b is always greater.
                                return -1 * val.SortOrder;
                            }
                            return (first - second) * val.SortOrder;
                        });
                                
                        this.filteredRows.sort(function (a, b) {
                            var first = self.ChangeNumeric(a.RowValues[index]);
                            var second = self.ChangeNumeric(b.RowValues[index]);

                            if (isNaN(first)) {
                                return val.SortOrder;
                            }
                            if (isNaN(second)) {
                                return -1 * val.SortOrder;
                            }
                            return (first - second) * val.SortOrder;
                        });
                    } else if (val.ColumnType === 'date' || val.ColumnType === 'time' || val.ColumnType === 'datetime') {
                        this.Rows.sort(function (a, b) {
                            //Sorting by date involves turning into a date (which is a number type) and sorting it by that.
                            var firstDate = new Date(a.RowValues[index]);
                            var secondDate = new Date(b.RowValues[index]);

                            if (isNaN(firstDate)) {
                                return val.SortOrder;
                            }
                            if (isNaN(secondDate)) {
                                return -1 * val.SortOrder;
                            }
                            return firstDate > secondDate ? val.SortOrder : -1 * val.SortOrder;
                        });
                        this.filteredRows.sort(function (a, b) {
                            var firstDate = new Date(a.RowValues[index]);
                            var secondDate = new Date(b.RowValues[index]);

                            if (isNaN(firstDate)) {
                                return val.SortOrder;
                            }
                            if (isNaN(secondDate)) {
                                return -1 * val.SortOrder;
                            }
                            return firstDate > secondDate ? val.SortOrder : -1 * val.SortOrder;
                        });
                    } else { //sort the rows by this column
                        this.Rows.sort(function (a, b) {
                            if (a.RowValues[index] == b.RowValues[index]) {
                                return 0;
                            }
                            if (a.RowValues[index] > b.RowValues[index]) {
                                return val.SortOrder;
                            }
                            return -1 * val.SortOrder;
                        });
                        
                        this.filteredRows.sort(function (a, b) {
                            if (a.RowValues[index] == b.RowValues[index]) {
                                return 0;
                            }
                            if (a.RowValues[index] > b.RowValues[index]) {
                                return val.SortOrder;
                            }
                            return -1 * val.SortOrder;
                        });
                    }
                }
                else {
                    val.SortOrder = 0;
                }
            }
            //Pulls the rows for the current page.
            this.ChangePage(this.CurrentPage);
        },
        //Handles pageination.
        ChangePage: function(newPage)
        {
                  
            if (newPage > this.pageCount)
            {
                this.CurrentPage = this.pageCount;
            }
            else if (newPage < 1)
            {
                this.CurrentPage = 1;
            }
            else
            {
                this.CurrentPage = newPage;
            }
            this.changeCurrentRows();
        },
        ChangePageSize: function () {
            //This implements a difference between PageSizeUse and PageSize, mostly because we don't want blanking the field to get confused, but do want to allow it.
            if (this.PageSize === null || this.PageSize === undefined || this.PageSize === '') {
                return;
            }
            this.PageSizeUse = this.PageSize;
            this.ChangePage(this.CurrentPage);
        },
        ChangeNumeric: function(num) {
            //Replaces a starting ( with a negative (-) sign, then removes "," , ")", and "$"... may need to be expanded if we ever go more global.
            //Basically used so we can do sorting with numbers in currency (c) or numeric (n) string format without including the numeric version of them.
            return num.replace(/^\(/, '-').replace('$', '').replace(/,/g, '').replace(/\)\s*$/, "");          
        },
        isNumber: function (evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            }
        },
        //Selects everything in a listbox.
        CheckAll: function (criteria, sender)
        {
            criteria.ValueList = [];
            for (var index = 0, len = criteria.ReportCriteriaOptions.length; index < len; index++) {
                criteria.ValueList.push(criteria.ReportCriteriaOptions[index].Value);
            }
        },
        //Turns all rows into a csv file.  Note that I found it more "browser neutral" to make the CSV on my own, since I was getting some fails before I did it this way.
        exportRowsToCSV: function()
        {
            var rtn = "";
            for (var index = 0, len = this.Columns.length; index < len; index++) {
                var value = this.Columns[index];
                if (index !== 0)
                {
                    rtn += ",";
                }
                rtn += '"' + value.Title + '"';
            }
            rtn += "\r";
            for (var ri = 0, len = this.filteredRows.length; ri < len; ri++)
            {
                var rv = this.filteredRows[ri];
                for (var index = 0, len2 = rv.RowValues.length; index < len2; index++) {
                    var value = rv.RowValues[index];
                    var columnTitle = this.Columns[index].Title;
                  
                    //strip html to prevent formatting issues when exporting
                    if (this.selectedReport.ID === this.$reportTypes.NotificationHistory && columnTitle == "Message") {
                        value = value.replace(/(<([^>]+)>)/ig,"");
                    }

                    if (index !== 0)
                    {
                        rtn += ","
                    }
                    if (this.JSONParse(value) !== value)
                    {
                        rtn += '"' + this.JSONParse(value).Value + '"';
                    }
                    else
                    {
                        rtn += '"' + value + '"';
                    }
                    
                }
                rtn += "\r";
            }
            var info = encodeURIComponent(rtn);
            var fileName = this.selectedReport.Description + ".csv";
            if (window.navigator.msSaveOrOpenBlob)
            {
                var fileData = info;
                var blobObject = new Blob([rtn]);
                var a = document.createElement('a');
                a.onclick=function(){
                    window.navigator.msSaveOrOpenBlob(blobObject, fileName);
                }
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            else if (this.$usingIE())
            {
                var IEwindow = window.open("text/html", "replace");
                IEwindow.document.write('sep=,\r\n' + info);
                IEwindow.document.close();
                IEwindow.focus();
                IEwindow.document.execCommand('SaveAs', true, fileName);
            }
            else
            {
                var html = "<a id='downLoadFile' href='data:text/csv;charset=utf8," + encodeURIComponent(rtn) + "' download='" + this.selectedReport.Description + ".csv'></a>";
                var encodedUri = encodeURIComponent(rtn);
                var link = document.createElement("a");
                link.setAttribute("href", 'data:text/csv;charset=utf8,' + encodedUri);
                link.setAttribute("download", this.selectedReport.Description + ".csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        },
        //Just opens the ReportPage_PrinterFriendly.html, for the printer friendly version.
        printerFriendly: function()
        {
            //It's important to call this with window.open, since this sets up the calling parent.
            store.commit('setFilteredRows', this.filteredRows);
            store.commit('setColumns', this.Columns);
            store.commit('setTopAddHTML', this.topAddHTML);
            store.commit('setSelectedReport', this.selectedReport);

            let routeData = this.$router.resolve({name: 'PrinterFriendly' });
            window.open(routeData.href, '_blank');
        },
        //Given a data key, finds the corresponding column value and returns that value's index.
        indexByKey: function(datakey)
        {
            for (var index = 0; index < this.Columns.length; index++) {
                if (this.Columns[index].DataKey == datakey) {
                    return index;
                }
            }
        },
        loadReportByParameters: function() {
            var sd = decodeURI(this.$route.query.StartDate);
            var ed = decodeURI(this.$route.query.EndDate);
            var rn = decodeURI(this.$route.query.ReportName);

            if (sd === undefined || ed === undefined || rn === undefined) {
                //We did not get SSO parameters
                return;
            }

            var useRpt = -1;

            for (var i = 0; i < this.reports.length; i++)
            {
                if (this.reports[i].Description.toLowerCase() === rn.toLowerCase())
                {
                    this.selectedReport = this.reports[i];
                    useRpt = i;
                    break;
                }
            }
            if (useRpt === -1) {
                //we got everything, but not a valid report.  Again, they'll just get to choose.
                return;
            }
            this.selectedDateRange = 4; //Custom Range
            this.rangeChange();
            this.startDate = sd;
            this.endDate = ed;
            //Using functions I already have set up to set the "Store" values.
            this.beginChange(sd);
            this.endChange(ed);
            //Finally, run the report.
            this.runReport();
        },
        showError(message) {
            this.$toasted.global.error(message);
            this.$announcer.set(message);
        }
    },

    mounted () {
        var path = this.$httpAxiosBaseUrl() + "Report/GetReportList?date=" + new Date().getTime();

        // if we already have the global reports items, no need to make another call.

        axios({
            method: "GET",
            url: path,
            async: false
        }).then(result => {
            result = result.data;
            //put it both in the global store and the local variable.
            store.commit('setReports', result);
            this.reports = result;
            path = this.$httpAxiosBaseUrl() + "Report/GetPremises?date=" + new Date().getTime();
                axios({
                    method: "GET",
                    url: path,
                    async: false
                }).then(result => {
                    result = result.data;
                    //put it both in the global store and the local variable.
                    store.commit('setPremises', result);
                    this.premises = result;
                    this.selectedPremiseID = this.$store.getters.getSelectedPremiseID;
                    // If we don't have a valid PremiseId, update the value based on premises object
                    if (this.selectedPremiseID === -1) {
                        this.selectedPremiseID = this.premises.length ? this.premises[0].PremiseId : this.selectedPremiseID;
                    }
                    //Load report by parameters will run the report, if we got the
                    //appropriate params.
                    this.loadReportByParameters();
                    this.showReportPage = true;

                });
            });
    }
}

</script>

<style scoped>
.mainArea .panel-primary .panel-body {
    border: 0;
}

.mainArea .PayGo_report_main_table {
    display: table;
}
.negativered {
    color: red;
}
#divReports #ddlReport {
    width: 38%;
}

.rpt-subrpt-click {
    cursor: pointer;
}

.rpt-subrpt-expanded td {
    border-bottom: 0px !important;
}

.rpt-subrpt-expanded td:last-child, .rpt-subrpt-click td:last-child {
    border-right: 1px solid gray;
}
</style>
